import {Preloader} from "components/Preloader";
import {noop} from "lodash";
import React, {Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {SSO} from "modules/utils/SSO";
import styled from "@emotion/styled";
import {checkUserName} from "modules/actions";
import {
	getCheckUsernameRequestState,
	getIsUserHasUsername,
	getLoginPayload,
} from "modules/selectors";

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	height: 400px;
	font-size: 16px;

	color: #ffffff;

	a {
		display: inline-flex;
	}
`;

interface IProps {
	children: React.ReactElement;
}

export const HOCCheckUserName: React.FC<IProps> = ({children}) => {
	const dispatch = useDispatch();
	const hasUsername = useSelector(getIsUserHasUsername);
	const loginPayload = useSelector(getLoginPayload);
	const {isSuccess} = useSelector(getCheckUsernameRequestState);
	const isValid = isSuccess && hasUsername;

	useEffect(() => {
		if (loginPayload.uid) {
			dispatch(
				checkUserName({
					uid: loginPayload.uid,
				})
			);
		}
	}, [dispatch, loginPayload.uid]);

	useEffect(() => {
		if (isSuccess && !hasUsername) {
			const timeout = setTimeout(SSO.TO_GAME_REDIRECT, 5000);

			return () => {
				clearTimeout(timeout);
			};
		}

		return noop;
	}, [hasUsername, isSuccess]);

	if (isValid || SSO.IS_BACKDOOR_MODE) {
		return <Fragment>{children}</Fragment>;
	}

	if (isSuccess && !hasUsername) {
		return (
			<Wrapper>
				Please create a username in your <a href="http://mlb.com/">MLB.com</a> account
				before playing MLB By The Numbers.”
			</Wrapper>
		);
	}

	return <Preloader fixed />;
};
